export default __webpack_public_path__ + "static/media/Manifest EGO_ Greater Split Horizontal.b84edc73.png";